import React, { useState } from 'react'
import PropTypes from "prop-types";
import GalleryImage from './GalleryImage';
import './style.css';
import { Link } from 'react-router-dom';
import GalleryImage2 from './GalleryImage2';
import { Card } from 'react-bootstrap';

const LoadMoreImage2 = ({ id, eventName, images, openImageViewer }) => {

    // const [imgCount, setImgCount] = useState(4); 
    //const [images] = useState(props?.images)
    const openImageView = (id, docId, eventName, i) => {
        openImageViewer(id, docId, eventName, i)
    }
    return (
        <>
            {/* <button style={{position: 'absolute',left: '75%', marginTop:'2%', background:'none', border:'none'}}
            onClick={()=>setImgCount(prevCount=>prevCount+5)}>View More</button> */}
            {images.slice(0, 3).map((img, i) => (
                <div
                className="col-lg-3 col-sm-3 col-xs-3 mx-2"
                    onClick={() => {
                        openImageView(id, img.docId, eventName, i)
                    }} key={`${img.id}_${img.docId}`}>
                    <Card key={`key_${i}`} className="imgCard gridImage1" >
                        <GalleryImage2
                            // style={{ margin: "2px" }}
                            eventName={eventName} image={img} />
                        {i == 2 && <Link to={`/eventgallery/${id}`} className="viewMore1" >View More</Link>}
                    </Card>
                </div>
            ))}
        </>
    )
}

export default LoadMoreImage2;

LoadMoreImage2.propTypes = {
    id: PropTypes.number,
    images: PropTypes.array,
    eventName: PropTypes.string,
    openImageViewer: PropTypes.func
}
